import { useLoading } from '@/context/loading-context'
import { Loader2 } from 'lucide-react'

const LoadingOverlay = () => {
    const { isLoading, message } = useLoading()

    if (!isLoading) return null

    return (
        <div className='fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center'>
            <div className='bg-white p-8 rounded-lg shadow-lg flex flex-col items-center gap-4'>
                <Loader2 className='w-8 h-8 animate-spin text-primary-main' />
                <p className='text-lg font-medium text-primary-main'>{message}</p>
            </div>
        </div>
    )
}

export default LoadingOverlay
